import { useAnalyticsV3Context } from '../../hooks/useAnalyticsV3Context';
import { useShallow } from 'zustand/react/shallow';
import OnCallUsers from './components/OnCallUsers';
import FilterDrawer from './components/filter-drawer';
import TopCard from './components/TopCard';

export default function OnCallAnalytics() {
  return (
    <div>
      <OnCallUsers />
      <FilterDrawer />
    </div>
  );
}
